/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import api from "../../api/api";
import Style from "../../assets/css/main.module.css";
import addIcon from "../../assets/icons/add.svg";
import calenderIcon from "../../assets/icons/calender.svg";
import caretDownIcon from "../../assets/icons/caret-down-dark.svg";
import uploadIcon from "../../assets/icons/upload.svg";
import { drawerAction } from "../../store/features/deviceSlice";
import addChildrenSchema from "../../validation/addChildrenSchema";
import Item from "../children/Item";
import { useDrawer } from "../drawer/DrawerProvider";
import ErrorMessage from "../ui/ErrorMessage";

export default function Children() {
  const [children, setChildren] = useState([]);
  const { openDrawer } = useDrawer();
  const handleChildrenAddDrawer = () => {
    openDrawer(<AddChildren />, "Add Child");
  };
  const fetchData = useCallback(async () => {
    const res = await api.getChildren();
    if (res.status === 200) {
      setChildren(res.data.data);
    }
  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <div style={{height: '100vh', overflowY:'scroll'}}>
      <div>
        <button
          type="button"
          onClick={handleChildrenAddDrawer}
          className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} text-light border-0 rounded px-3 d-flex align-items-center m-3 ms-4`}
          style={{ height: "43px" }}
        >
          <div>
            <img src={addIcon} alt="add-icon" />
          </div>
          <div className="ps-2">
            <span>Add a New Child</span>
          </div>
        </button>
      </div>
      <div className="pt-3">
        {children.map((item, index) => (
          <Item key={item.id} item={item} index={index} />
        ))}
      </div>
    </div>
  );
}
function AddChildren() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const initial = {
    name: "",
    date_of_birth: null,
    gender: "",
    class: "",
    school: "",
    profile: "",
  };
  const [credentials, setCredentials] = useState(initial);
  const [errors, setErrors] = useState(null);
  const credentialHandler = (event) => {
    const { name, value } = event.target;
    setCredentials({ ...credentials, [name]: value });
  };
  const allowOnlyNumbers = (event) => {
    const regex = /^[0-9]+$/;
    if (!regex.test(event.data)) {
      event.preventDefault();
    }
  };
  const selectedDate = (name, value) => {
    setCredentials({ ...credentials, [name]: value });
  };
  const profileCredentialHandler = (event) => {
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const maxSize = 1 * 1024 * 1024;
    const file = event.target.files[0];
  
    if (file) {
      if (!validTypes.includes(file.type)) {
        alert('Please upload a valid image file (JPG, JPEG, or PNG).');
        return;
      }

      if (file.size > maxSize) {
        alert('File size should not exceed 1MB.');
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setCredentials({ ...credentials, profile: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };
  const saveChildrenHandler = async () => {
    try {
      const result = addChildrenSchema.safeParse(credentials);
      if (result.success) {
        setErrors(null);
        setLoading(true);
        const formData = new FormData();
        formData.append(
          "date_of_birth",
          new Date(credentials.date_of_birth).toISOString().slice(0, 10)
        );
        formData.append("name", credentials.name);
        formData.append("gender", credentials.gender);
        formData.append("class", credentials.class);
        formData.append("school", credentials.school);
        if (
          typeof credentials.profile === "string" &&
          credentials.profile.startsWith("data:image")
        ) {
          const blob = await (await fetch(credentials.profile)).blob();
          formData.append("profile", blob, "photo.png");
        } else if (credentials.profile instanceof File) {
          formData.append("profile", credentials.profile);
        }
        const res = await api.addChildren(formData);
        if (res.status === 201) {
          dispatch(drawerAction(false));
          setCredentials(initial);
          toast.success("Child added successfully");
        } else if (res.status === 422) {
          Object.values(res.data.data).forEach((item) => {
            toast.error(item[0]);
          });
        } else {
          toast.error("Server side error!Please try again later");
        }
        setLoading(false);
      } else {
        const errorsObject = result.error.errors.reduce((acc, error) => {
          const path = error.path.join(".");
          acc[path] = error.message;
          return acc;
        }, {});
        setErrors(errorsObject);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <div className="w-100 h-100 px-2 px-md-4">
      <div className="profile-container overflow-y-scroll pt-3 pb-2">
        <div className="d-flex flex-column gap-2 px-4 pt-5">
          <div className="pe-4">
            {credentials.profile && (
              <img
                src={credentials.profile}
                style={{ width: "114px", height: "114px", borderRadius: "50%" }}
                alt="Captured"
              />
            )}
          </div>
          <div className="d-flex justify-content-between gap-2 w-100 pt-4">
            <div className="w-100">
              <input
                type="file"
                id="upload"
                onChange={profileCredentialHandler}
                hidden
                accept=".jpg,.jpeg,.png"
              />
              <label
                htmlFor="upload"
                className={`${Style.custom_uploader} ${Style.bg_primary} ${Style.fs_600} ${Style.fw_16} border-0 rounded d-flex align-items-center text-light gap-1 btn btn-sm`}
                style={{ height: "43px", width: "100%" }}
              >
                <span>
                  <img src={uploadIcon} alt="upload" />
                </span>
                <span>Choose from Gallery</span>
              </label>
            </div>
          </div>
          <div className={Style.profile_input}>
            <input
              type="text"
              name="name"
              className="w-100 rounded"
              placeholder="Enter Name"
              onChange={credentialHandler}
            />
            {errors && errors.name && <ErrorMessage message={errors.name} />}
          </div>
          <div
            className={`${Style.profile_input} ${Style.children_custom_date} position-relative`}
          >
            <DatePicker
              className="w-100 rounded"
              selected={credentials.date_of_birth}
              onChange={(date) => selectedDate("date_of_birth", date)}
              dateFormat="dd/MM/yyyy"
              showYearDropdown
              scrollableYearDropdown
              yearDropdownItemNumber={100}
              showMonthDropdown
              maxDate={new Date()}
              placeholderText="Select Date of Birth"
            />
            <img
              src={calenderIcon}
              alt="caret-down"
              className="position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          {errors && errors.date_of_birth && (
            <div>
              <ErrorMessage message={errors.date_of_birth} />
            </div>
          )}
          <div className={`${Style.profile_input} position-relative`}>
            <select
              name="gender"
              className={`${credentials.gender ? "text-dark" : Style.color_gray_200} w-100 rounded`}
              onChange={credentialHandler}
            >
              <option value="">Select Gender</option>
              <option value="male">Boy</option>
              <option value="female">Girl</option>
            </select>
            <img
              src={caretDownIcon}
              alt="caret-down"
              className="position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
            {errors && errors.gender && (
             <div> <ErrorMessage message={errors.gender} /></div>
            )}
          <div className={Style.profile_input}>
            <input
              type="text"
              name="class"
              className="w-100 rounded"
              placeholder="Enter Class"
              onChange={credentialHandler}
              onBeforeInput={allowOnlyNumbers}
            />
            {errors && errors.class && <ErrorMessage message={errors.class} />}
          </div>
          <div className={Style.profile_input}>
            <input
              type="text"
              name="school"
              className="w-100 rounded"
              placeholder="Enter School Name"
              onChange={credentialHandler}
            />
            {errors && errors.school && (
              <ErrorMessage message={errors.school} />
            )}
          </div>
        </div>
      </div>
      <div className="profile-bottom">
        {!loading && (
          <button
            type="button"
            onClick={saveChildrenHandler}
            className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 py-1 save-btn`}
          >
            Add Child
          </button>
        )}
        {loading && (
          <button
            disabled
            type="button"
            className={`${Style.bg_primary} ${Style.fs_20} ${Style.fw_600} border-0 text-light w-100 py-1 save-btn`}
          >
            <Spinner animation="border" role="status" size="sm">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </button>
        )}
      </div>
    </div>
  );
}
